if (typeof(module) !== "undefined" && module.exports) {
    /* Load for NodeJS */
    module.exports.phrasebook = require("./phrasebook.js").phrasebook;
    module.exports.loader = require("./loader.js").loader;
    module.exports.languages = require("./languages.js").languages;
    module.exports.loader = require("./loader.js").loader;
    module.exports.preferences = require("./preferences.js").preferences;
    module.exports.selector = require("./selector.js").selector;
    module.exports.autotranslate = require("./autotranslate.js").autotranslate;
} else {
    /* Load for web browser */
    window.cx_libtranslate = {
        phrasebook: require("./phrasebook.js").phrasebook,
        loader: require("./loader.js").loader,
        languages: require("./languages.js").languages,
        translation: require("./translation.js").translation,
        preferences: require("./preferences.js").preferences,
        selector: require("./selector.js").selector,
        autotranslate: require("./autotranslate.js").autotranslate
    };
}
